export const ADDITIONAL_NDA_COVENANTS_BUYER_TOOLTIP =
    'Applies only to the Due Diligence NDA. This becomes relevant only if your offer is selected.';
